/**
 * document-management の document_type（および旧 ind-1 形式）を
 * PATCH /property-sections/:id/documents の body.category に渡すスラグへ変換する。
 * 対応は backend sectionDocumentService の INDIVIDUAL_FIELD_MAP / CORPORATE_FIELD_MAP と整合させる。
 */
export function documentTypeToPatchCategory(documentType: string): string {
  const t = String(documentType || "");
  const map: Record<string, string> = {
    lease_contract_file: "contract",
    id_document_file: "id",
    income_proof_file: "income",
    guarantor_docs_file: "guarantor",
    other_file: "other",
    registry_cert_file: "registry",
    seal_cert_file: "seal",
    articles_file: "articles",
    corporate_other_file: "other",
    "ind-1": "contract",
    "ind-2": "id",
    "ind-3": "income",
    "ind-4": "guarantor",
    "corp-1": "contract",
    "corp-2": "registry",
    "corp-3": "seal",
    "corp-4": "articles",
  };
  return map[t] || "other";
}
